<template lang="pug">
  .panel.panel-default
    //- 交換者の交換情報一覧
    .panel-heading
      .row
        .col-xs-4
          router-link.btn.btn-default(:to="{name: 'box-exchangers', params: { sidPerson }}" title="戻る"): i.fa.fa-reply
        .col-xs-4.text-center
          h4.form-control-static {{userName}} の名刺交換履歴
    .panel-body.-exchanges-bg
      exchange-history-list(
        :sid-person="sidPerson",
        :user-id="sidUser",
        @delete="onDelete"
      )
</template>

<script>
import ExchangeHistoryList from '@/components/organisms/lists/ExchangeHistoryList'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const UserRepository = RepositoryFactory.get('user')

export default {
  name: 'CardTabExchangerExchanges',
  components: {
    ExchangeHistoryList
  },
  props: {
    sidPerson: { type: [String, Number], required: true },
    sidUser: { type: [String, Number], required: true },
    item: { type: Object, required: false, default: null }
  },
  data () {
    return {
      isLoading: true,
      user: {
        full_name: '---'
      }
    }
  },
  computed: {
    userName () {
      return (this.item && this.item.exchanger_full_name) || this.user.full_name
    }
  },
  created () {
    // URL直接遷移
    if (!this.item) {
      this.getProfile()
    }
  },
  methods: {
    getProfile () {
      const vm = this
      UserRepository.profile(this.sidUser)
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            const data = vm.getApiData(response).data
            vm.user = {
              full_name: data.full_name
            }
          }
        })
        .finally(function () {
          if (!vm.user.full_name) {
            vm.user = {
              full_name: '???'
            }
          }
        })
    },
    /**
     *
     * @param exchangesLength
     */
    onDelete (exchangesLength) {
      if (exchangesLength > 0) {
        this.$emit('reload')
      }
      else {
        // 交換情報が全部消えた＝交換者が1人消えたので交換者一覧に戻る
        // 最後の1人の交換者が消えていた場合は、戻ったときにCardのwatch.nameによる
        // 処理で「閲覧中の名刺情報は削除されました」が表示される
        this.$router.push({name: 'box-exchangers', params: {sidPerson: this.sidPerson}})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .panel-heading h4 {
    margin: 0;
  }
  .panel-body.-exchanges-bg {
    background: #efefef;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/box/CardTabExchangerExchanges.vue